// extracted by mini-css-extract-plugin
module.exports = {"main":"MaxWidthContainer_main__26174"};